import React, { PureComponent } from 'react'
import { Button, OverlayTrigger, Popover, Table } from 'react-bootstrap'
import Lightbox from 'react-image-lightbox'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { disableImage } from '../../actions/disable_image'
import { assignError } from '../../actions/error_management'
import { closeLightbox, openLightbox } from '../../actions/lightbox'
import { closeSrcLightbox, openSrcLightbox } from '../../actions/src_lightbox'
import { verifyDocument } from '../../actions/verify_document'
import { DOCUMENT_CATEGORY_DUI_IMAGE, DOCUMENT_CATEGORY_RESIDENT, DOCUMENT_CATEGORY_SELFIE } from '../../config'
import { filterIdDocumentType } from '../../utils/filters'
import { getImageSrc } from '../../utils/images'
import ErrorAssignmentModal from './error_assignment_modal'
import PhotoCompareModal from './photoCompareModal/photoCompareModal'
import PdfModalDialog from './verification_documents/pdf_modal_dialog'
import TablePdfVerificationDocs from './verification_documents/table_pdf_verification_docs'

class IdPhotos extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showModalCompare: false,
      isModalDialogOpen: false,
      errorObjectID: null,
      selectedDocuments: [],
      isAllSelected: false,
      verified: false,
      items: [],
      type: null,
    }
  }

  toggleModalCompare = (type) => {
    if (this.state.showModalCompare) {
      this.setState({ showModalCompare: false, type: null })
    } else {
      this.setState({ showModalCompare: true, type })
    }
  }

  groupData = (inputArr, i, groupBy, acc) => {
    if (acc.length === Math.ceil(inputArr.length / groupBy)) {
      return acc
    }
    let arr = inputArr.slice(i, i + groupBy)
    // pad array with empty objects
    if (arr.length < groupBy) {
      while (arr.length < groupBy) {
        arr.push({ id: null })
      }
    }
    acc.push(arr)
    return this.groupData(inputArr, i + groupBy, groupBy, acc)
  }

  openErrors = (id) => this.setState({ isModalDialogOpen: true, errorObjectID: id })

  closeErrors = () =>
    this.setState({
      isModalDialogOpen: false,
    })

  verifyDocument = () => {
    this.setState({ verified: true })
    this.state.selectedDocuments.forEach((id) => this.props.verifyDocument(this.props.identity, id))
  }

  checkVerificationPossibility = (selected) =>
    this.props.accreditedInvestorData
      .filter((entity) => entity.status !== 'verified')
      .reduce((filtered, entity) => {
        if (!selected.includes(entity.id)) {
          filtered.push(entity)
        }
        return filtered
      }, []).length === 0

  selectDocument = (id) => {
    if (!this.state.selectedDocuments.includes(id)) {
      const selectedDocuments = [...this.state.selectedDocuments, id]
      this.setState({ selectedDocuments })
      this.setState({
        isAllSelected: this.checkVerificationPossibility(selectedDocuments),
      })
    }
  }

  unselectDocument = (id) => {
    const index = this.state.selectedDocuments.indexOf(id)
    if (index !== -1) {
      const selectedDocuments = [...this.state.selectedDocuments]
      selectedDocuments.splice(index, 1)
      this.setState({ selectedDocuments })
      this.setState({
        isAllSelected: this.checkVerificationPossibility(selectedDocuments),
      })
    }
  }

  componentDidMount() {
    const items = this.props.data
      .filter((entry) => entry.is_active && entry.state !== 'disabled')
      .filter(filterIdDocumentType)
    this.setState({
      verified: this.checkVerificationPossibility(this.props.accreditedInvestorData),
    })
    this.setState({ items })
  }

  disableImage = async ({ identity, id }) => {
    if (window.confirm('Are you sure you want to disable image?')) {
      try {
        await this.props.disableImage(identity, id)
        window.location.reload()
      } catch (e) {
        console.log(e)
      }
    } else {
      return false
    }
  }

  render() {
    const { props, state } = this
    const {
      openLightbox,
      closeLightbox,
      isLightboxOpen,
      photoSrc,
      closeSrcLightbox,
      isSrcLightboxOpen,
      singleImgSrc,
      errors,
    } = props
    const { items, type } = state
    const counter = new Map()
    items.forEach((i) => counter.set(i.document_type, (counter.get(i.document_type) || 0) + 1))
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div style={{ borderRadius: '10px 10px 0 0' }} className='ibox-title'>
          <h5>Verification Documents</h5>
        </div>
        <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
          {items.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  {items.map((entry, i) => (
                    <th key={i}>{entry.document_type.toUpperCase()}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {items.map((entry, i) => (
                    <td key={i}>
                      <div className='netki-preview-landscape'>
                        <img
                          alt='document'
                          style={{ cursor: 'pointer', flex: 1 }}
                          onClick={(e) => openLightbox(entry.document)}
                          src={getImageSrc(entry)}
                        />
                        {(!entry.expiration_date || !entry.document_classification) &&
                          counter.get(entry.document_type) > 1 && (
                            <i
                              onClick={() => this.disableImage(entry)}
                              title={'Deactivate Image'}
                              className='fa fa-trash fa-2x'
                              aria-hidden='true'
                              onMouseOver={(e) => (e.target.style.color = '#ff0000')}
                              onMouseLeave={(e) => (e.target.style.color = 'rgba(255, 0, 0, 0.52)')}
                              style={{ cursor: 'pointer', color: 'rgba(255, 0, 0, 0.52)' }}
                            />
                          )}
                        {props.aeb ? (
                          <Button style={{ marginTop: '10px' }} onClick={() => this.openErrors(entry.id)}>
                            Attach Error
                          </Button>
                        ) : null}
                      </div>
                    </td>
                  ))}
                </tr>
              </tbody>
            </Table>
          ) : (
            <span>{'N/A'}</span>
          )}
          {items.length >= 2 && (
            <div>
              <div className='text-center'>
                <Button onClick={() => this.toggleModalCompare(DOCUMENT_CATEGORY_SELFIE)} variant={'default'}>
                  Compare Photo ID and Selfie
                </Button>
                {counter.get(DOCUMENT_CATEGORY_DUI_IMAGE) && (
                  <>
                    &nbsp;
                    <Button onClick={() => this.toggleModalCompare(DOCUMENT_CATEGORY_DUI_IMAGE)} variant={'default'}>
                      Compare Selfie and DUI
                    </Button>
                  </>
                )}
                {counter.get(DOCUMENT_CATEGORY_RESIDENT) && (
                  <>
                    &nbsp;
                    <Button onClick={() => this.toggleModalCompare(DOCUMENT_CATEGORY_RESIDENT)} variant={'default'}>
                      Compare Selfie and Resident
                    </Button>
                  </>
                )}
              </div>
              <PhotoCompareModal
                toggleModalCompare={this.toggleModalCompare}
                showModalCompare={state.showModalCompare}
                data={props.data}
                category={type}
              />
            </div>
          )}
          {state.isModalDialogOpen && (
            <ErrorAssignmentModal
              errorObjectID={state.errorObjectID}
              contentType={26}
              filter='document'
              closeErrors={this.closeErrors}
              isModalDialogOpen={state.isModalDialogOpen}
              allErrors={errors}
            />
          )}
          {isLightboxOpen && <Lightbox mainSrc={photoSrc} onCloseRequest={() => closeLightbox()} />}
          {props.accreditedInvestorData.length > 0 && (
            <div>
              {state.verified && <h5>Accreditation Documents</h5>}
              {!state.verified && <h5>Investor Accreditation</h5>}
              <Table bordered className='m-t-sm'>
                <tbody>
                  <TablePdfVerificationDocs
                    unselectDocument={this.unselectDocument}
                    selectDocument={this.selectDocument}
                    data={props.accreditedInvestorData}
                    verified={state.verified}
                  />
                </tbody>
              </Table>
              {!state.isAllSelected && (
                <OverlayTrigger
                  rootClose
                  overlay={
                    <Popover id={'verifyPopover'}>
                      Please verify all of the individual documents separately first
                    </Popover>
                  }
                >
                  <div className='ibox-title-link' style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                    <Button style={{ pointerEvents: 'none' }} disabled size={'sm'} variant={'success'}>
                      Verified
                    </Button>
                  </div>
                </OverlayTrigger>
              )}
              {state.isAllSelected && (
                <div className='ibox-title-link'>
                  <Button size={'sm'} variant={'success'} disabled={state.verified} onClick={this.verifyDocument}>
                    Verified
                  </Button>
                </div>
              )}
            </div>
          )}
          <PdfModalDialog />
          {isSrcLightboxOpen && <Lightbox mainSrc={singleImgSrc} onCloseRequest={() => closeSrcLightbox()} />}
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => ({
  isLightboxOpen: state.lightbox.isLightboxOpen,
  photoSrc: state.lightbox.photoSrc,
  singleImgSrc: state.srcLightbox.src,
  isSrcLightboxOpen: state.srcLightbox.isSrcLightboxOpen,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openLightbox,
      closeLightbox,
      openSrcLightbox,
      closeSrcLightbox,
      assignError,
      verifyDocument,
      disableImage,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(IdPhotos)
